
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g3qL5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8Hqv7 = parcelRequire("8Hqv7");


var $2VZOl = parcelRequire("2VZOl");


var $l1kdf = parcelRequire("l1kdf");


var $98zed = parcelRequire("98zed");


var $1NBp8 = parcelRequire("1NBp8");


var $kE2cJ = parcelRequire("kE2cJ");


var $6mKj3 = parcelRequire("6mKj3");


var $6gETM = parcelRequire("6gETM");


var $8jRXE = parcelRequire("8jRXE");


var $c0rhi = parcelRequire("c0rhi");

const $f9df14c16cd36eb8$export$99fa8db8497fb663 = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType })=>{
    const [isUnpublishedDraft, setIsUnpublishedDraft] = (0, $42omo.useState)(// With this flag on we are matching the logic in NativeCollabComponent
    // confluence/next/packages/native-collab/src/NativeCollabComponent.tsx#getDraftMeta
    (0, $6mKj3.expVal)('platform_editor_no_is_unpublished_draft_in_ssr', 'isEnabled', false) ? !!draftShareId : false);
    const livePageSSRStatus = (0, $98zed.useIsLivePageWithSSR)();
    if (livePageSSRStatus.isTypeKnown && livePageSSRStatus.isLive) // Remove draftShareId if it exists, to avoid persisting it on live doc. If the param exists on live doc, it prevents SSR from preloading live doc title/content
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.VIEW_PAGE).name,
        params: {
            contentId: contentId,
            spaceKey: spaceKey
        },
        excludedQueryParams: [
            'draftShareId'
        ]
    });
    if (!(0, $6mKj3.expVal)('platform_editor_no_is_unpublished_draft_in_ssr', 'isEnabled', false)) (async ()=>{
        const queryResult = await (0, $c0rhi.queryInterop)({
            query: (0, $l1kdf.NativeCollabQuery),
            variables: {
                contentId: contentId,
                status: [
                    'draft',
                    'current'
                ],
                ...draftShareId && {
                    draftShareId: draftShareId
                }
            },
            fetchPolicy: 'cache-first',
            context: {
                single: 'true'
            }
        });
        const newUnpublishedDraft = !queryResult.data?.content?.nodes?.[0]?.history?.createdBy;
        if (newUnpublishedDraft !== isUnpublishedDraft) setIsUnpublishedDraft(newUnpublishedDraft);
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Hqv7.FullCycleRenderWithProfiler), {
        name: "edit-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jRXE.FullPageEditorLoader), {
        isUnpublishedDraft: isUnpublishedDraft,
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        collabEditState: {},
        heartbeatData: {},
        disabled: true
    }))));
};
module.exports["EditPageLoaderServer"] = $f9df14c16cd36eb8$export$99fa8db8497fb663;

});

parcelRegister("98zed", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");


var $eNbbn = parcelRequire("eNbbn");

const $91141199ce9a5735$export$899773b8bcad4fc7 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    const ssrStatus = (0, $eNbbn.useLivePageSSRStatus)();
    if (!ssrStatus.isTypeKnown && isTransition) return {
        isLive: undefined,
        isTypeKnown: false
    };
    return ssrStatus;
};
module.exports["useIsLivePageWithSSR"] = $91141199ce9a5735$export$899773b8bcad4fc7;

});


//# sourceMappingURL=EditPageLoaderServer.3333c2db.js.map
